import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { NoticeListModel } from "features/stock-ordering/core/domain/notice.model";
import {
  GetNoticesRepository,
  GetNoticesResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum GetAdminNoticesState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetAdminNoticesState;
  message: string;
  data: NoticeListModel | undefined;
}

const initialState: InitialState = {
  status: GetAdminNoticesState.initial,
  message: "",
  data: undefined,
};

export const getAdminNotices = createAsyncThunk(
  "getAdminNotices",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetNoticesResponse = await GetNoticesRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const getAdminNoticesSlice = createSlice({
  name: "getAdminNotices",
  initialState,
  reducers: {
    resetGetAdminNotices: (state) => {
      state.status = GetAdminNoticesState.initial;
      state.data = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminNotices.pending, (state) => {
        state.status = GetAdminNoticesState.inProgress;
      })
      .addCase(getAdminNotices.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetAdminNoticesState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getAdminNotices.rejected, (state, action) => {
        state.status = GetAdminNoticesState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetAdminNotices = (state: RootState) =>
  state.getAdminNotices;
export const { resetGetAdminNotices } = getAdminNoticesSlice.actions;
export default getAdminNoticesSlice.reducer;
